import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useQuery from '../../hooks/useQuery'
import useRunway from '../../hooks/useRunway'
import { get } from '../../lib/http'
import { Result } from '../../lib/http/type'
import Client from '../../models/client'
import Delivery from '../../models/delivery'
import PageState from '../../types/pageState'
import orderItemsToSelectedItems from '../QuickSale/utilities/orderItemsToSelectedItems'
import { storagePage } from './storage'
import { Order, PaymentTypeResponse } from './types'
import useStorage from '../../hooks/useStorage'

export default function useInitial() {
    const [pageState, setPageState] = useState(PageState.LOADING)
    const { order_id } = useParams<{ order_id?: string }>()
    const { account_id } = useParams<{ account_id?: string }>()
    const { client_id, delivery_id, action } =
        useQuery<{ client_id: string; delivery_id: string; action: string }>()
    const { saveSelectedItems } = useRunway()
    const { business_variables } = useStorage()

    async function load() {
        const request: Array<Promise<any>> = [
            get<Client>(`/api/clients/1`),
            get<PaymentTypeResponse>('/api/type_payments/all')
        ]

        if (order_id && !account_id) {
            request.push(get<Order>(`/api/account_orders/${order_id}/items`))
        }

        const [result1, result3, result4] = (await Promise.all(request)) as [
            Result<Client>,
            Result<PaymentTypeResponse>,
            Result<Order>
        ]

        if (result1.error) {
            setPageState(PageState.ERROR)
            return
        }

        if (order_id && !account_id && result4.error) {
            setPageState(PageState.ERROR)
            return
        }
        storagePage.clientSelected = result1.data.result
        storagePage.print_sale_note = business_variables.find(
            v => v.code === '001'
        )?.value
        storagePage.generate_electronic_receipts = business_variables.find(
            v => v.code === '002'
        )?.value

        storagePage.paymentTypes = result3.data.result.result
        if (order_id && !account_id) {
            storagePage.selectedItems = orderItemsToSelectedItems(
                result4.data.result.order_items
            )
            saveSelectedItems(storagePage.selectedItems)
            storagePage.table_id = result4.data.result.table_id
        }

        if (delivery_id && client_id) {
            const responseDel = await get<Delivery>(
                `/api/deliveries/${delivery_id}`
            )
            if (responseDel.error) {
                setPageState(PageState.ERROR)
                return
            }
            storagePage.to = 'delivery'
            storagePage.deliveryId = Number(delivery_id)
            storagePage.alias = ''
            storagePage.deliveryPrice = Number(
                responseDel.data.result.delivery_price
            )
            storagePage.table_id = 0
        }

        setPageState(PageState.SUCCESS)
    }

    useEffect(() => {
        load()

        return () => {
            if (order_id) {
                saveSelectedItems([])
            }
            storagePage.reason = ''
            storagePage.type = null
            storagePage.discount = 0
            storagePage.to = 'eat'
            storagePage.typeDiscount = ''
            storagePage.clientSelected = null
            storagePage.cash = []
            storagePage.card = []
            storagePage.transfer = []
            storagePage.tipWithCard = []
            storagePage.alias = ''
            storagePage.deliveryId = 0
            storagePage.deliveryPrice = 0
            storagePage.table_id = 0
        }
    }, [])

    return {
        pageState,
        order_id,
        account_id,
        client_id,
        delivery_id,
        table_id: storagePage.table_id,
        action
    }
}
